import React, { useState } from "react";
import { OuterBox } from "./styles";
import { BaseInput, Ptag } from "components/core";
import { TpaDetailInputWrapper } from "components/Flex/styles";
import { theme } from "theme";
import { Button, Checkbox, FormControlLabel, Stack } from "@mui/material";

const MaternityCoverge = ({ label, formikProps }) => {
  const [babyButton, setBabyButton] = useState("");
  const [referDefault, setDefault] = useState(false);
  const setBabyCoverage = (val) => {
    setBabyButton(val);
    formikProps.setFieldValue("baby_coverage_limit", val);
  };
  const handleChange = () => {
    setDefault(prevVal => !prevVal);
    setBabyButton("")
    formikProps.setFieldValue("maternity_coverage_limit", null);
    formikProps.setFieldValue('metro_normal_delivery', "");
    formikProps.setFieldValue("metro_icu_maternity", "");
    formikProps.setFieldValue('non_metro_normal_delivery_limit', "");
    formikProps.setFieldValue('non_metro_icu_limit', "")
  }
  return (
    <OuterBox>
      <FormControlLabel
        required
        control={<Checkbox sx={{ "& .MuiSvgIcon-root": { fontSize: 20 } }} onChange={()=>handleChange()}/>}
        label={
          <Ptag fontSize='16px' fontWeight='600'>Please Refer Policy Document</Ptag>
        }
      />
      <div style={{ marginBottom: "2rem" }}>
        <Ptag fontSize="14px" marginTop="10px" fontWeight="700">
          {"Metro Cities"}
        </Ptag>
        <TpaDetailInputWrapper marginTop="0.4rem">
          <div>
            <BaseInput
              formatToRupee
              disabled={referDefault}
              label="Normal Delivery Limit"
              fontSize="16px !imortant"
              variant="standard"
              formikProps={{
                ...formikProps,
                name: "metro_normal_delivery",
              }}
            />
          </div>
          <div>
            <BaseInput
              formatToRupee
              disabled={referDefault}
              label="C-Sec Limit"
              fontSize="16px !imortant"
              variant="standard"
              formikProps={{
                ...formikProps,
                name: "metro_icu_maternity",
              }}
            />
          </div>
        </TpaDetailInputWrapper>
        <Ptag fontSize="14px" marginTop="26px" fontWeight="700">
          {"Non-Metro Cities"}
        </Ptag>
        <TpaDetailInputWrapper marginTop="0.4rem">
          <div>
            <BaseInput
              formatToRupee
              disabled={referDefault}
              label="Normal Delivery Limit"
              fontSize="16px !imortant"
              variant="standard"
              formikProps={{
                ...formikProps,
                name: "non_metro_normal_delivery_limit",
              }}
            />
          </div>
          <div>
            <BaseInput
              formatToRupee
              disabled={referDefault}
              label="C-Sec Limit"
              fontSize="16px !imortant"
              variant="standard"
              formikProps={{
                ...formikProps,
                name: "non_metro_icu_limit",
              }}
            />
          </div>
        </TpaDetailInputWrapper>
        {/* <Ptag fontSize="14px" color={theme.baseBlue} fontWeight="500">
          {"Baby Coverage"}
        </Ptag> */}
        <Ptag fontSize="14px" marginTop="26px" fontWeight="700">
          {"Baby Coverage"}
        </Ptag>
        <TpaDetailInputWrapper
          marginTop="0.4rem"
          style={{ paddingTop: "10px" }}
        >
          <Stack spacing={2} direction="row">
            <Button
              sx={{ fontSize: "1.2rem", minWidth: "100px" }}
              // disabled={referDefault}
              variant={babyButton == "YES" ? "contained" : "outlined"}
              name="baby_coverage_limit"
              onClick={(e) => setBabyCoverage("YES", e)}
            >
              YES
            </Button>
            <Button
              sx={{ fontSize: "1.2rem", minWidth: "100px" }}
              // disabled={referDefault}
              variant={babyButton == "NO" ? "contained" : "outlined"}
              name="baby_coverage_limit"
              onClick={(e) => setBabyCoverage("NO", e)}
            >
              NO
            </Button>
          </Stack>
        </TpaDetailInputWrapper>
        {/* <TpaDetailInputWrapper marginTop="0.4rem">
        <div>
            <BaseInput
              formatToRupee
              label="Enter Amount"
              fontSize="16px !imortant"
              variant="standard"
              formikProps={{
                ...formikProps,
                name: "baby_coverage_limit",
              }}
            />
          </div>
        </TpaDetailInputWrapper> */}
      </div>
    </OuterBox>
  );
};
export default MaternityCoverge;
